/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Performs security logging.
 * @param {object} testRunner - The test runner object.
 * @param {string} reason - The reason for the security log action.
 * @param {object?} details - The details for the security log action.
 */
export const securityLog = (testRunner, reason, details) => {
    testRunner.getProxy().callTestAction('security-log', {
        action: 'flag',
        reason,
        details
    });
};
